module.exports = __webpack_public_path__ + "img/order.a3f33456.png";